exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".salva-ricerca-mobile[data-v-ec961958] {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  padding: 5px !important;\n}", ""]);

// exports
